<template>
    <div>
        Reservation updated component
<!--        bu kısım tablette karşılığı olmadığı için şu an için beklemede-->
    </div>
</template>
<script>
export default {
    name: "ReservationUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
